import Feature from './components/Feature';
function DevBypassFeature({ children, ...props }) {
  if (process.env.NODE_ENV === "development") return <>{children}</>;
  return <Feature {...props}>{children}</Feature>;
}

export default DevBypassFeature